<template>
  <section class="core">
    <div class="container">
      <a-typography-title :level="1">
        产品功能
      </a-typography-title>
      <a-typography-paragraph>
        <span>三大看板，优化点一目了然</span>
        <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">；</template>
        <br v-else />
        <span>一键体检，优化策略信手拈来</span>
      </a-typography-paragraph>
      <a-tabs v-model:activeKey="tab.active" centered>
        <a-tab-pane v-for="(item,index) in tab.list"
                    :key="index+1" :tab="item.title">
          <a-row :class="{tab_show:tab.show===index+1}">
            <a-col :xs="24" :lg="{offset:1,span:10}">
              <div class="media" :class="`m_${index+1}`">
                <img v-if="item.image" alt=""
                     :src="item.image" />
                <video v-if="item.video"
                       :src="item.video" :controls="$FN.Agent.client()==='Mobile'"
                       preload autoplay loop muted />
              </div>
            </a-col>
            <a-col :xs="24" :lg="{offset:2,span:10}">
              <div class="item" :class="`i_${index+1}`">
                <a-typography-title v-if="item.sub" :level="5">
                  {{ item.sub }}
                </a-typography-title>
                <a-typography-paragraph v-for="v in item.text">
                  {{ v }}
                </a-typography-paragraph>
                <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
                  <a-button type="link" class="button_1"
                            @click="$RQ.GoGSS()">
                    免费体验
                  </a-button>
                  <a-button type="link" class="button_1"
                            @click="$Store.Page().openModal('modalFormCollection','demo')">
                    预约咨询
                  </a-button>
                </a-space>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/page/productCostPilot/content_2_1.png';
import Image_2 from '@resource/image/page/productCostPilot/content_2_2.png';
import Image_3 from '@resource/image/page/productCostPilot/content_2_3.png';

export default {
  name: 'product_core',
  data(): DataInterface {
    return {
      tab: {
        active: 1,
        show: 1,
        list: [
          {
            title: '深度成本洞察',
            sub: '费用、算力、利用率三大看板，实现成本可视化',
            text: [
              '从云厂商、云账号、云产品等多个维度分析成本，还可下钻到业务、应用层做进一步洞察',
              '支持日、月、季、年等多个时间维度，环比、同比等多个视角，快速洞察成本变化'
            ],
            image: Image_1
          },
          {
            title: '专业成本体检',
            sub: '实时一键成本体检，挖掘成本优化点',
            text: [
              '支持多种体检维度（业务线、应用等），按业界标准进行综合评分',
              '根据资源利用率情况快速定位资源浪费，并给出具体优化操作',
              '支持K8s集群体检，推荐Node和Pod最佳配置'
            ],
            image: Image_2
          },
          {
            title: '轻松成本运营',
            sub: '成本可预测，预算分配合理化，轻松实现持续运营',
            text: [
              '可为不同账号、业务线和应用设置预算，超预算则及时告警',
              '根据历史费用预测未来花费，为成本控制提供依据',
              '日、月、季、年等多个时间维度的邮件报表，持续掌控成本变化',
              '账单管理：云账号、应用等多个维度的账单聚合、查询、按月比对'
            ],
            image: Image_3
          }
        ]
      },
      expand: {
        width: 0
      }
    };
  },
  watch: {
    'tab.active': {
      async handler(newData: any, oldDate: any): Promise<any> {
        await $FN.WaitTime(50);
        this.tab.show = newData;
      }
    }
  },
  methods: {
    /**
     * 点击按钮
     */
    async clickButton(): Promise<any> {
      window._hmt && window._hmt.push([ '_trackEvent', 'CostPilot_2', 'click' ]);
      await $FN.WaitTime(100);
      $Store.Page().openModal('modalFormCollection', 'freeUse');
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.core {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
  
  &::before {
    content: '';
    display: block;
    .position(bottom, -15px);
    width: 72px;
    height: 3px;
    margin: 0 auto;
    background-color: @color_6;
  }
}

div.ant-typography {
  margin: @margin 0 0;
  .font(center, @text+@line, @color_3, @text);
}

.ant-tabs {
  overflow: initial;
  margin: 0;
  
  &:deep(.ant-tabs-nav) {
    &::before {
      display: none;
    }
    
    .ant-tabs-nav-list {
      position: relative;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, auto, 0, 1px, 50%);
        z-index: 0;
        width: 200%;
        border-bottom: 1px solid @color_3;
        .transform(translateX(-50%) scale(0.5));
      }
      
      .ant-tabs-ink-bar {
        height: 3px;
      }
    }
    
    .ant-tabs-tab {
      padding: 20px;
      .font(center, @text_big, @color_12, @text_big, true);
      
      &.ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: @color_6;
        }
      }
    }
    
    .ant-tabs-ink-bar {
      background-color: @color_6;
    }
  }
  
  &:deep(.ant-tabs-content) {
    .ant-tabs-tabpane {
      .tab_show {
        .media,
        .item {
          opacity: 1;
          .transform(translate(0, 0));
        }
      }
      
      .media {
        .transform(translate(-100px, 0));
      }
      
      .item {
        .transform(translate(100px, 0));
      }
      
      .media,
      .item {
        @aTime: 1s;
        @style: transform @aTime, opacity @aTime;
        opacity: 0;
        .transition(@style);
      }
    }
  }
}

.ant-row {
  .ant-col {
    position: relative;
  }
}

.media {
  position: relative;
  height: 320px;
  
  img,
  video {
    .position();
    display: block;
    width: 100%;
    max-width: 520px;
    max-height: 100%;
    margin: auto;
  }
  
  img {
  }
  
  video {
    background: @color_white;
    border-radius: 5px;
  }
}

.item {
  .position();
  max-width: 500px;
  height: 220px;
  margin: auto;
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    position: relative;
    padding-left: 20px;
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_3, @text);
    
    &:nth-child(2) {
      margin: 20px 0 0;
    }
    
    &::before {
      content: '';
      display: block;
      .position(absolute, 10px, auto, auto, 0);
      width: 8px;
      height: 8px;
      margin: auto 0;
      border-radius: 4px;
      background-color: @color_6;
    }
  }
  
  .ant-space {
    margin: 20px 0 0;
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .ant-tabs {
    &:deep(.ant-tabs-content) {
      .ant-tabs-tabpane {
        .media {
          @aTime: 1s;
          @style: transform @aTime, opacity @aTime;
          .transition(@style);
        }
        
        .item {
          @aTime: 1s;
          @dTime: 0.2s;
          @style: transform @aTime @dTime, opacity @aTime @dTime;
          .transition(@style);
        }
        
        .media,
        .item {
          .transform(translate(0, 50px));
        }
      }
    }
  }
  
  .media {
    height: auto;
    margin: 0 0 20px;
    
    img,
    video {
      position: relative;
    }
  }
  
  .item {
    position: relative;
    height: auto;
    text-align: center;
    
    .ant-space {
      margin: @margin_mo auto 0;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .core {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
    
    &::before {
      display: none;
    }
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0 !important;
    .font(center, @text_mo+@line_mo, @color_3, @text_mo);
  }
  
  .ant-tabs {
    &:deep(.ant-tabs-nav) {
      .ant-tabs-tab {
        padding: 10px 0;
        .font(center, @font_7+@line, @color_black, @font_7, true);
        
        &.ant-tabs-tab-active {
          .ant-tabs-tab-btn {
            color: @color_6;
          }
        }
      }
      
      .ant-tabs-ink-bar {
        background-color: @color_6;
      }
    }
  }
  
  .item {
    max-width: 350px;
    
    h5.ant-typography {
      .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_3, @text_mo);
    }
  }
}
</style>